exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.label[data-v-cbbba6d4]{font-weight:bold\n}\n.pad5[data-v-cbbba6d4]{padding:25px 10px\n}\n", "", {"version":3,"sources":["/builds/youx-group/sicarf/sicarf-parametrizavel/frontend/src/components/resumo/AppResumoCadastranteAreasPatrimoniais.vue"],"names":[],"mappings":";AA4EA,wBACE,gBAAiB;CAClB;AAAA,uBAEC,iBAAkB;CACnB","file":"AppResumoCadastranteAreasPatrimoniais.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.label {\n  font-weight: bold;\n}\n.pad5 {\n  padding: 25px 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cbbba6d4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/resumo/AppResumoCadastranteAreasPatrimoniais.vue
// module id = V8nt
// module chunks = 12